kombi.loginModalAutoOpen = {
  _timerId: null,

  init: function () {
    const metaTag = document.querySelector('meta[name="login-modal-appear-time"]');
    if (!metaTag) {
      return;
    }

    const delayMs = (parseInt(metaTag.getAttribute("content"), 10) || 0) * 1000;
    if (delayMs === 0) {
      return;
    }

    const loginButton = document.querySelector("#LoginButton");
    if (!loginButton) {
      return;
    }

    this.schedule(delayMs);

    const signForm = document.querySelector("#SignForm");
    if (signForm) {
      signForm.addEventListener("show.bs.modal", this.cancel.bind(this));
    }
  },

  schedule: function (delayMs) {
    this.cancel();
    const self = this;
    this._timerId = window.setTimeout(function () {
      self._timerId = null;
      const loginButton = document.querySelector("#LoginButton");
      if (loginButton) {
        loginButton.click();
      }
    }, delayMs);
  },

  cancel: function () {
    if (this._timerId) {
      window.clearTimeout(this._timerId);
      this._timerId = null;
    }
  },
};

kombi.googleOneTap = {
  waitForGoogle: function (callback, attempts) {
    let remaining = attempts || 50;

    function tryInit() {
      if (
        window.google &&
        google.accounts &&
        google.accounts.id
      ) {
        callback();
        return;
      }

      remaining -= 1;
      if (remaining <= 0) {
        return;
      }

      window.setTimeout(tryInit, 100);
    }

    tryInit();
  },

  handleCredential: function (response, callbackUrl, nextUrl) {
    fetch(callbackUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        credential: response.credential,
        next_url: nextUrl,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          return null;
        }
        return res.json();
      })
      .then(function (data) {
        if (data && data.redirect_url) {
          window.location.href = data.redirect_url;
        }
      })
      .catch(function () {});
  },

  init: function () {
    const configEl = document.getElementById("google-one-tap-config");
    if (!configEl) {
      return;
    }

    const clientId = configEl.dataset.clientId;
    const callbackUrl = configEl.dataset.callbackUrl;
    const nextUrl = configEl.dataset.nextUrl || "/";

    if (!clientId || !callbackUrl) {
      return;
    }

    kombi.googleOneTap.waitForGoogle(function () {
      google.accounts.id.initialize({
        client_id: clientId,
        context: "signin",
        use_fedcm_for_prompt: true,
        callback: function (response) {
          kombi.googleOneTap.handleCredential(response, callbackUrl, nextUrl);
        },
      });

      google.accounts.id.prompt();
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  if (kombi.googleOneTap) {
    kombi.googleOneTap.init();
  }
});
